export default {
  // ReportedTask.vue translations
  addMember: "اضافة عضو",
  email: "البريد الالكتروني",
  emailExistsError: "هذا البريد الالكتروني مسجل بالفعل. يرجى استخدام بريد الكتروني اخر.",
  generalError: "حدث خطأ في التقديم. يرجى المحاولة مرة اخرى في وقت لاحق.",
  invalidCompanyIdOrUserId: "معرف الشركة أو معرف المستخدم غير صحيح.",
  routineTaskDeleted: "تم حذف المهمة الروتينية بنجاح.",
  routineTaskAdded: "تم اضافة المهمة الروتينية بنجاح.",
  deleteConfirmationTitle: "حذف المهمة الروتينية",
  deleteConfirmationText: "هل تريد حذف هذه المهمة الروتينية؟",
  delete: "حذف",
  addRoutineTask: "اضافة مهمة روتينية",
  routineTaskName: "اسم المهمة الروتينية",
  description: "وصف المشروع",
  close: "اغلاق",
  create: "اضافة",
  reportedTasksTable: "تقارير المهام الروتينية",
  routineTaskNameRequired: "يرجى ادخال اسم المهمة الروتينية.",
  routineTaskAddedError: "حدث خطأ في اضافة المهمة الروتينية. يرجى المحاولة مرة اخرى في وقت لاحق.",
  from: "من",
  to: "إلى",
  routineTaskManager: "مدير المهمة الروتينية",
  assignManager: "تعيين المدير",
  enterDescription: "ادخال الوصف",
  enterRoutineTaskName: "ادخال اسم المهمة الروتينية",
  createRoutineTask: "اضافة مهمة روتينية",
  saving: "يتم الحفظ...",
  noRoutineTasks: "لا يوجد مهام روتينية.",
  createee: "انشئ مهامك الروتينية ",
  inactive: "غير نشط",
  active: "نشط",
  advancedSettings: "الإعدادات المتقدمة",
  taskNumber: "رقم المهمة",
  taskType: "نوع المهمة",
  selectTaskType: "اختر نوع المهمة",
  recurrentDays: "أيام التكرار",
  enterRecurrentDays: "ادخل عدد أيام التكرار",
  dayOfMonth: "يوم الشهر",
  enterDayOfMonth: "ادخل يوم الشهر مثل 1, 2,....31",
  department: "قسم",
  selectDepartment: "اختر القسم",
  sunday: "الاحد",
  monday: "الاثنين",
  tuesday: "الثلاثاء",
  wednesday: "الاربعاء",
  thursday: "الخميس",
  friday: "الجمعة",
  saturday: "السبت",
  enterStartDate: "ادخل تاريخ البدء",
  startDate: "تاريخ البدء",
  status: "حالة",
  allTypes: "جميع النوايات",
  allStatuses: "جميع الحالات",
  allDepartments: "جميع القسوم",
  weekly: "اسبوعي",
  monthly: "شهري",
  last_day_of_month: "اخر يوم من الشهر",
  daily: "يومي",
  applyFilters: "تطبيق التصفيات",
  resetFilters: "اعادة تعيين التصفيات",
  selectAll: "اختر الكل",
  departmentsSelected: "اقسام محددة",
  filterByDate: "تصفية حسب التاريخ",
  reported: "تقرير",
  not_reported: "لم يتم التقرير",
  searchPlaceholder: "...ابحث هنا",
  evaluated_Task: "المهام المقيدة",
  done: "تم التقرير",
  notDone: "لم يتم التقرير",
  clearAll: "مسح الكل",
  
  // ReportedTaskTable.vue translations
  tasksTable: "جدول المهام",
  taskName: "اسم المهمة",
  edit: "تعديل",
  deleteConfirmationSuccess: "تم حذف المهمة بنجاح.",
  update: "تحديث",
  taskUpdatedSuccessfully: "تم تحديث المهمة بنجاح",
  taskDeletedSuccessfully: "تم حذف المهمة بنجاح",
  taskReportedSuccessfully: "تم تقرير المهمة بنجاح",
  taskCreatedBy: "تم الإنشاء بواسطة",
  taskDetails: "تفاصيل المهمة",
  createdAt: "تاريخ إنشاء المهمة",
  deadline: "المهلة النهائية",
  log: "سجل",
  info: "معلومات",
  statusUpdatedSuccessfully: "تم تحديث الحالة بنجاح",
  errorUpdatingStatus: "حدث خطأ في تحديث الحالة",
  errorUpdatingTask: "حدث خطأ في تحديث المهمة",
  errorDeletingTask: "حدث خطأ في حذف المهمة",
  noLogsAvailable: "لا يوجد سجلات متاحة",
  changedTheField: "قام بتغيير الحقل",
  onDate: "في تاريخ",
  editTask: "تعديل المهمة",
  noTasks: "لا يوجد مهام.",
  taskStartDate: "تاريخ بدء المهمة",
  taskDeadline: "تاريخ انتهاء المهمة",
  reportTaskType: "تقرير المهمة",
  dayOfWeek: "يوم الاسبوع",
  fromTime: "من الوقت",
  taskCreatedSuccessfully: "تم انشاء المهمة بنجاح",
  taskCreatedSuccessfullyMessage: "تم انشاء المهمة بنجاح",
  taskCreationError: "حدث خطاء في انشاء المهمة",
  report: "تقرير",
  reportTask: "تقرير المهمة",
  selectReportTaskType: "حدد نوع المهمة",
  notes: "ملاحظات",
  taskStatus: "حالة المهمة",
  notReported: "لم يتم التقرير عن المهمة",
  enterNotes: "ادخل ملاحظات",
  employeeName: "اسم الموظف",
  at: "في",
  reporttime: "وقت التقرير",
  lateTime: "التأخير",
  fromDate: "من تاريخ",
  toDate: "إلى تاريخ",
  applyFilter: "تطبيق الفلتر",
  found: "تم العثور على المهمة",
  evaluation: "تقييم",
  evaluate: "تقييم",
  evaluatedAt: "تم التقييم في",
  evaluatedBy: "تم التقييم بواسطة",
  reportedBy: "تم التقرير بواسطة",
  evaluated: "تم التقييم",
  taskFound: "هناك مهمة؟",
  selectTaskFound: "حدد المهمة الموجودة",
  project: "المشروع",
  projectNotFound: "لا يوجد مشروع",
  rating: "التقييم",
  comment: "التعليق",
  elvatedAllready: "هذه المهمة تم التقييم عنها بالفعل",
  priority: "الاولوية",
  randomTask: "المهام العشوائية المطلوب تقييمها",
  selectDate: "اختر التاريخ",
};

